module.exports = __webpack_public_path__ + "img/perform-fill.dfb30f17.svg";